<template>
  <div
      :class="['image-container', { holder: !imgLoaded }, 'read-only']"
      :data-url="url"
      :data-thumbnailUrl="thumbnailUrl"
      :data-attachmentId="attachmentId"
      :data-description="description"
      :data-filename="filename"
      :data-width="width"
      :data-height="height"
      :data-unwell="unwell"
  >
    <div class="image-inner-container">
      <no-ssr>
        <unwell-mask v-if="unwellMaskVisible" @unlock="unlockUnwell"></unwell-mask>
      </no-ssr>
      <span v-if="!unwellMaskVisible">
        <svg-icon v-if="imgError" class="visible-img" name="uploadf" @mousedown.prevent></svg-icon>
        <img v-else class="visible-img" :data-src="url" :src="thumbnailUrl" :alt="filename" @mousedown.prevent @load="onLoad" @error="onError">
      </span>
    </div>
    <p class="desc-input" v-show="!!description">{{description}}</p>
  </div>
</template>
<script>
import UnwellMask from '../../common/UnwellMask.vue'
import NoSSR from 'vue-no-ssr'
export default {
  components: {
    'unwell-mask': UnwellMask,
    'no-ssr': NoSSR
  },
  data() {
    return {
      description: '', // 图片描述
      url: '', // 图片地址 在线的
      thumbnailUrl: '', // 缩略图
      attachmentId: '', // 附件id
      filename: '', // 图片的文件名称 用于alt展示
      width: '', // 图片的宽度
      height: '', // 图片的高度
      imgLoaded: false, // 图片加载完成 onload 和 onerror 执行完都会为true，为了避免一直转圈的问题
      imgError: false, // 图片出错了
      unwell: 0, // 图片是否引人不适
      lockUnwell: 0 // 引人不适的图片是否需要解锁观看
    };
  },
  created () {
    console.log(this.unwell, 'unwell')
  },
  computed: {
    unwellMaskVisible() {
      return +this.lockUnwell && +this.unwell === 1
    },
  },
  methods: {
    // 图片加载完成
    onLoad() {
      this.imgLoaded = true;
    },
    // 图片加载失败了
    onError() {
      this.imgError = true;
      this.imgLoaded = true;
    },
    // 解锁当前引人不适的图片
    unlockUnwell() {
      this.lockUnwell = 0
    }
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
